module.exports = __webpack_public_path__ + "static/media/03.5c767a00.jpg";